import {
  Control,
  Controller,
  FieldPath,
  FieldPathValue,
  UnpackNestedValue,
  UseFormSetValue,
} from 'react-hook-form';
import TextEditor from '~/ui/components/inputs/TextEditor';

interface IProps<TFormValues> {
  name: FieldPath<TFormValues>;
  placeholder: string;
  control: Control<any>;
  setValue: UseFormSetValue<TFormValues>;
}

const NoteTextEditor = <TFormValues,>({
  name,
  placeholder,
  control,
  setValue,
}: IProps<TFormValues>) => (
  <Controller
    name={`${name}Html`}
    control={control}
    render={({ field }) => (
      <TextEditor
        value={field.value ?? ''}
        placeholder={placeholder}
        onChange={({ text, textHtml }) => {
          field.onChange(textHtml);

          setValue(
            name,
            text as UnpackNestedValue<FieldPathValue<TFormValues, FieldPath<TFormValues>>>,
            {
              shouldDirty: true,
              shouldValidate: true,
            },
          );
        }}
      />
    )}
  />
);

export default NoteTextEditor;
